// Oh god, I am so sorry

import svg from '../../images/shc-footsteps.svg';
import { constrain, isEditMode, randomBetween } from './helpers';

const footprintsAnimationQueue = [];
let animatingFootprints = false;

function enqueueFootprintsSet($set) {
	footprintsAnimationQueue.push($set);

	if (!animatingFootprints) {
		fadeInFootprint(getNextPrint());
	}
}

function getRandomPoint(xMin, xMax, yMin, yMax) {
	return {
		x: randomBetween(xMin, xMax),
		y: randomBetween(yMin, yMax)
	};
}

function calculateDuration($elem) {
	const st = $(window).scrollTop() || window.scrollY;
	const sb = st + window.innerHeight;
	const offset = $elem.offset().top;
	const expectedDuration = 300 * (offset / sb);

	return constrain(expectedDuration, 50, 300);
}

function fadeInFootprint($cur) {
	if (!$cur.data('animated')) {
		$cur.data('animated', true);
		animatingFootprints = true;

		$cur.animate(
			{
				opacity: 1
			},
			{
				duration: calculateDuration($cur),
				complete() {
					const $next = getNextPrint($cur);
					if ($next) {
						fadeInFootprint($next);
					} else {
						animatingFootprints = false;
					}
				}
			}
		);
	}
}

function getNextPrint($print) {
	if ($print && $print.hasClass('footprint-left')) {
		return $print.siblings('.footprint-right');
	}

	if ($print && $print.closest('.footprint-container').next().length) {
		return $print.closest('.footprint-container').next().find('.footprint-left');
	}

	if (footprintsAnimationQueue.length) {
		const $next = footprintsAnimationQueue.shift();

		return $next.find('.footprint-container').first().find('.footprint-left');
	}
}

function buildPath($from, $to, $printsContainer) {
	const __dist = $to.offset().left - $from.offset().left;
	const direction = Math.abs(__dist) / __dist; // Returns 1 if -> and -1 if <-

	const $startImg = $from.find('.experience-image');

	// region Calculate Start Point
	const startXMin = direction === 1 ? $startImg.position().left + $startImg.width() * 0.9 : $startImg.position().left;
	const startXMax = direction === 1 ? $startImg.position().left + $startImg.width() : $startImg.position().left + $startImg.width() * 0.1;
	let startY = $startImg.position().top + 50;

	if ($from.prev().length) {
		const $prevWrap = $from.prev().find('.experience-item-wrap');
		const prevBottom = $prevWrap[0].offsetTop + $prevWrap.height();

		if (startY < prevBottom) startY = prevBottom;
	}

	const startPos = getRandomPoint(startXMin, startXMax, startY, startY);

	// endregion

	const $printsSet = $('<div class="footprint-set" />');

	$printsContainer.append($printsSet);

	let w = 0;

	if (direction === -1) $printsSet.addClass('footprint-set-left');

	(function generateFootprint(prev, $prevElem) {
		const intensity = w / 8;
		const containerWidth = $printsContainer.width();

		const $print = $('<div class="footprint-container" />');

		$print.html(svg);

		if (direction === -1) $print.addClass('footprint-container-left');

		$printsSet.append($print);

		const positionTracker = {
			top: null,
			left: null,
			right: null,
			rotate: 0
		};

		if (!prev) {
			positionTracker.top = startPos.y;
			if (direction === 1) {
				positionTracker.left = startPos.x;
			} else {
				positionTracker.right = containerWidth - startPos.x;
			}
		} else {
			const topOffset = randomBetween($prevElem.height() / 2, $prevElem.height());
			positionTracker.top = prev.top + topOffset * intensity;
			if (direction === 1) {
				positionTracker.left = prev.left + $prevElem.width();

				positionTracker.rotate = Math.min(prev.rotate + randomBetween(14, 28) * intensity, 90);
			} else {
				positionTracker.right = prev.right + $prevElem.width();

				positionTracker.rotate = Math.max(prev.rotate - randomBetween(14, 28) * intensity, -90);
			}
		}

		$print.css({
			left: positionTracker.left,
			right: positionTracker.right,
			top: positionTracker.top,
			transform: 'rotateZ(' + positionTracker.rotate + 'deg)'
		});

		if (++w < 6) generateFootprint(positionTracker, $print);

	})();

	$from.data('prints', $printsSet);
}

$(window).on('load', function () {
	if (!isEditMode) {
		$('.experience').each(function () {
			const $container = $(this);
			const $items = $(this).find('.experience-item');
			const $printsContainer = $container.find('.experience-prints');

			$items.each(function () {
				const $item = $(this);

				if ($(this).next().length) {
					buildPath($item, $item.next(), $printsContainer);
				}

				var scrollTarget = $item.offset().top - window.innerHeight;

				$(window).on('scroll', function scrollHandler() {
					const st = $(this).scrollTop() || window.scrollY;

					if (st >= scrollTarget) {
						if ($item.data('prints')) enqueueFootprintsSet($item.data('prints'));

						$(window).off('scroll', scrollHandler);
					}
				});
			});
		});
	}
});
